import { render, staticRenderFns } from "./ShowBankInfo.vue?vue&type=template&id=1f99bd97&scoped=true&"
import script from "./ShowBankInfo.vue?vue&type=script&lang=js&"
export * from "./ShowBankInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99bd97",
  null
  
)

export default component.exports